import type Store from '@ember-data/store';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type { ModelSchema } from 'ember-data';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type { ModelRegistry } from 'ember-data/model';
import ApplicationSerializer from 'garaje/serializers/application';

interface FieldSettingApiItem {
  sign_in_field_id: number | null;
  data_category: string | null;
  display_name: string;
  is_selected: boolean;
  flow_version_id: number | null;
  flow_id: string;
}

interface FieldSettingApiResponse {
  field_settings: FieldSettingApiItem[];
}

export default class FieldSettingSerializer extends ApplicationSerializer {
  normalizeFindHasManyResponse(
    store: Store,
    primaryModelClass: ModelSchema<keyof ModelRegistry>,
    payload: FieldSettingApiResponse,
    id: string | number,
    requestType: string,
  ): ReturnType<ApplicationSerializer['normalizeFindHasManyResponse']> {
    const jsonApiPayload = {
      data: payload.field_settings.map((item) => {
        const suffix =
          item.sign_in_field_id !== null ? `field:${item.sign_in_field_id}` : `category:${item.data_category}`;
        return {
          type: 'field-settings',
          id: `flow:${item.flow_id}:${suffix}`,
          attributes: {
            'sign-in-field-id': item.sign_in_field_id,
            'data-category': item.data_category,
            'display-name': item.display_name,
            'is-selected': item.is_selected,
            'flow-version-id': item.flow_version_id,
          },
        };
      }),
    };

    return super.normalizeFindHasManyResponse(store, primaryModelClass, jsonApiPayload, id, requestType);
  }
}
